import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { API_ServerAddress } from '../MyAppCommonConfig';
import { CCompanyEquipment } from '../models/galery.models/companyEquipment.model';


@Injectable()
export class CompanyEquipmentService {
  constructor(private http: HttpClient) {

  }

  GetList() {
    // now returns an Observable of CCompanyEquipment[]
    return this.http.get<CCompanyEquipment[]>(API_ServerAddress + 'api/CompanyEquipments');
  }

  GetById(id: number) {
    return this.http.get<CCompanyEquipment>(API_ServerAddress + 'api/CompanyEquipments/' + id);
  }

}